import { MessageType } from '@/models/message'
import { Moment } from 'moment-timezone';
import { Utils } from '../util/utils';
import {copyTextToClipboard} from '../util/helper'

export const initializeGlobalMixins = (app: any) => {
  app.config.globalProperties.$mixins = {
    clipboardCopy: (text: string) => copyTextToClipboard(text),
    isCallType:( messageType: MessageType) =>  Utils.isCall(messageType),
    isEmailType: (messageType: MessageType) => Utils.isEmail(messageType),
    isWhatsAppType: (messageType: MessageType) => Utils.isWhatsApp(messageType),
    isActivityType: (messageType: MessageType) => Utils.isActivity(messageType),
    isEmptyStr: (str: string) => Utils.isEmptyStr(str),
    serverReady: (str: string) => Utils.serverReady(str),
    relativeTime:(m: Moment, suffix: string = 'ago' ) => Utils.relativeTime(m,suffix),
    tzTime: (m: Moment, timeZone: string) => Utils.tzTime(m,timeZone),
    getDateParts: (m: Moment, timeZone: string) => Utils.getDateParts(m,timeZone),
    getUserName: (id:string) => Utils.getUserName(id),
    cropDisplay:(item:string,len:number) => Utils.cropDisplay(item,len),
    convertTimestampToDate:(timestamp:any)=> Utils.convertTimestampToDate(timestamp)
  }
}
